export const debounce = (cb, delay = 1000) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            cb(...args)
        }, delay);
    }
}

export const debounceImage = (cb, delay = 1000) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
            cb(...args)
        }, delay);
    }
}

export const validations = {
    phoneNumber: /^\+?(\d{1,4})?\s?(?!0+$)\d{6,15}$/i,
    email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    fullName: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/i,
    blankSpace: /^(?!\s+$).*/i,
    number: /^\d+$/is,
    decimalNumbers: /^(?!(0\d|0$|0\.0*$))(\d+(\.\d+)?$)/is
}